function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 84.76 16.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -10.23,
    width: 85,
    height: 37,
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Soundbar-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.23,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.38,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.96,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.54,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.12,
    cy: 11.96,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.12,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.12,
    cy: 4.8,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.7,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.28,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.85,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.43,
    cy: 10.17,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.43,
    cy: 6.59,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.01,
    cy: 15.54,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.01,
    cy: 11.96,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.01,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.01,
    cy: 4.8,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.01,
    cy: 1.23,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.59,
    cy: 10.17,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.59,
    cy: 6.59,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.17,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.75,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.32,
    cy: 11.96,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.32,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.32,
    cy: 4.8,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.9,
    cy: 11.96,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.9,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.9,
    cy: 4.8,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.48,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.06,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.64,
    cy: 11.96,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.64,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.64,
    cy: 4.8,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.22,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.8,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.37,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.95,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.53,
    cy: 8.38,
    r: 1.23,
    style: {
      fill: "#20c58a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundbar);
export default __webpack_public_path__ + "static/media/soundbar.25a1f8a19505e1c9ec17bebe43b3088a.svg";
export { ForwardRef as ReactComponent };